<template>
  <div class="container page" :class="{ 'px-0': $vuetify.breakpoint.xsOnly }">
    <template v-if="error || deleteError">
      <GenericError />
    </template>
    <template v-else>
      <AppToolbar
        :title="vessel ? vessel.name : ''"
        :prev-route="
          vessel
            ? {
                name: 'OrganizationShow',
                params: { id: $iriToId(vessel.organization['@id']) }
              }
            : null
        "
      >
        <template v-if="vessel" slot="buttons">
          <ToolbarView
            :map-route="{
              name: 'VesselShowMap',
              params: { id: $route.params.id }
            }"
          ></ToolbarView>
        </template>
      </AppToolbar>

      <v-row v-if="vessel" class="align-center justify-center column mb-4">
        <v-avatar size="100" class="mb-2 mr-4">
          <img v-if="vessel.image" :src="vessel.image.contentUrl + '?x-request=html'" :alt="vessel.name" />
          <img v-else src="../../assets/no-img.svg" :alt="vessel.name" />
        </v-avatar>
        <div>
          <h1 class="headline">{{ vessel.name }}</h1>
          <router-link
            v-if="vessel"
            :to="{
              name: 'OrganizationShow',
              params: { id: $iriToId(vessel.organization['@id']) }
            }"
            class="subheading no-decoration"
            >{{ vessel.organization.name }}</router-link
          >
        </div>
      </v-row>

      <RoleInVesselList v-if="vessel" :vessel="vessel"></RoleInVesselList>
      <div
        :class="{
          'sidenav-speed-dial': true,
          'sidenav-speed-dial-sm': $vuetify.breakpoint.smAndDown
        }"
      >
        <v-speed-dial
          v-if="isShipowner || isCaptain || isFleetManager || isOfficer"
          v-model="fab"
          fixed
          dark
          fab
          bottom
          right
        >
          <template v-slot:activator>
            <v-btn color="orange" dark fab bottom right class="ma-0">
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-btn style="position: relative;" fab dark small color="green" @click="showUserShowDialog = true">
            <v-icon>mdi-account-plus</v-icon>
            <div class="speed-dial-tooltip elevation-1">
              {{ $t('message.new_user') }}
            </div>
          </v-btn>

          <v-btn style="position: relative;" fab dark small color="blue" @click="showRoleInVesselDialog = true">
            <v-icon>mdi-account-check</v-icon>
            <div class="speed-dial-tooltip elevation-1">
              {{ $t('message.associate_employee') }}
            </div>
          </v-btn>
        </v-speed-dial>
      </div>
    </template>
    <UserDialog
      :show="showUserShowDialog"
      :user="selectedUser"
      :vessel="vessel"
      @close="showUserShowDialog = false"
    ></UserDialog>
    <RoleInVesselDialog
      :show="showRoleInVesselDialog"
      :vessel="vessel"
      @close="showRoleInVesselDialog = false"
    ></RoleInVesselDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar'
import RoleInVesselList from '@/components/roleinvessel/List'
import ToolbarView from '@/components/ToolbarView'
import RoleInVesselDialog from '@/components/roleinvessel/dialog/Dialog.vue'
import UserDialog from '@/components/user/dialog/Dialog.vue'
import GenericError from '@/components/error/GenericError'

export default {
  components: {
    UserDialog,
    RoleInVesselDialog,
    ToolbarView,
    AppToolbar,
    GenericError,
    RoleInVesselList
  },

  data() {
    return {
      isShipowner: false,
      isCaptain: false,
      isFleetManager: false,
      isOfficer: false,
      fab: false,
      showRoleInVesselDialog: false,
      showUserShowDialog: false,
      selectedUser: null
    }
  },

  computed: mapGetters({
    deleted: 'vessel/del/deleted',
    deleteError: 'vessel/del/error',
    error: 'vessel/show/error',
    isLoading: 'vessel/show/isLoading',
    vessel: 'vessel/show/retrieved'
  }),

  watch: {
    vessel: function(vessel) {
      if (!vessel) {
        return
      }

      this.isShipowner = this.$security.isGranted(vessel.organization['@id'], 'ROLE_SHIPOWNER')
    }
  },

  beforeDestroy() {
    this.reset()
  },
  showUserShowDialog: function(showUserShowDialog) {
    if (false === showUserShowDialog) {
      this.selectedUser = null
    }
  },
  fab(val) {
    this.tooltips = false
    this.tooltipsDisabled = false
    val &&
      setTimeout(() => {
        this.tooltips = true
        this.$nextTick(() => (this.tooltipsDisabled = true))
      }, 250)
  },
  created() {
    this.$store.commit('mapSetShow', false)
    this.retrieve('/vessels/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      del: 'vessel/del/del',
      reset: 'vessel/show/reset',
      retrieve: 'vessel/show/retrieve'
    }),
    selectUser: function(user) {
      this.selectedUser = user['@id']
      this.showUserShowDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.speed-dial-tooltip {
  position: absolute;
  right: 50px;
  padding: 8px 15px;
  background: white;
  color: rgba(0, 0, 0, 0.87);
  text-transform: none;
  font-weight: normal;
  letter-spacing: normal;
  border-radius: 3px;
}
</style>
